import DeployingFromBitbucket from "../../../../src/courses/partials/responsible-development/deploying-from-version-control/bitbucket.mdx";
import * as React from 'react';
export default {
  DeployingFromBitbucket,
  React
};